module.exports = __webpack_public_path__ + "img/Calendar.64545e8c.svg";